import React from 'react';
import { IColumn } from  '@/interfaces/IContentTable';
import CellContent from './CellContent';
import { BuildPath } from  '@/helpers/Paths';
import DirectionIcon from './DirectionIcon';

type Props = {
    data:any, 
    val:string, 
    idx:number, 
    columnsFiltered:IColumn[], 
    count:number, 
    total:number,
    detailsModal?:boolean
}

const CellContainer = ({data, val, idx, columnsFiltered, count, total, detailsModal} : Props) => {

    // Index
    if (val === "id"){

        // Ranking direction instead of index
        if (!Number.isInteger(data[val]) && data[val].directionStats && data[val].directionStats.direction){

            const dir = data[val].directionStats ? data[val].directionStats.direction : null;

            return (
                <div className="idx">
                    <DirectionIcon numberDirection={dir} />
                </div>
            )
        }

        return (
            <div className="idx"><span>{idx+1}</span></div>
        )
    }

    // Image
    if (val === "image"){

        const src = data[val] === null || data[val] === "" ? `${BuildPath()}/images/missingimage.png` : `${data[val]}?size=Thumbnail`;

        return (
            <div className={`cell ${corners()} ${borderRight()} ${borderBottom()}`}>
                <img src={src} alt="" onError={onError} className="in-image" />
            </div>
        )
    }

    function onError(e) {
        e.target.src = `${BuildPath()}/images/missingimage.png`
    }
    
    function selectedColumn(colname:string){

        const currentOrder = columnsFiltered.filter(x => x.field === colname)[0];

        if (!currentOrder){
            console.log(`Missing col: ${colname}`);
        }
        
        if (currentOrder && currentOrder.order){
            return "selectedColumn"
        }

        return "";
    }

    function corners(){

        if (count === 2){
            return "leftCorner";
        }
        else if (count === (columnsFiltered.length)){
            return "rightCorner";
        }
        else if (count === (total - (columnsFiltered.length -2))){
            return "bottomLeftCorner";
        }
        else if (count === total){
            return "bottomRightCorner";
        }

        return "";
    }

    function borderRight(){
        if (!(count % columnsFiltered.length)){
            return "cell-end-right"
        }

        return "";
    }
    
    function borderBottom(){
        if (count >= (total - (columnsFiltered.length - 1))){
            return "cell-end-bottom"
        }

        return "";
    }

    return (       
        <div className={`cell ${selectedColumn(val)} ${corners()} ${borderRight()} ${borderBottom()}`}>
           <CellContent columnsFiltered={columnsFiltered} data={data} val={val} detailsModal={detailsModal}  />
        </div>
    );
}

export default CellContainer;